import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-practice-single',
  templateUrl: './practice-single.component.html',
  styleUrls: ['./practice-single.component.css']
})
export class PracticeSingleComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
